import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../../../ui/api/action.component';
import { ResultComponent } from '../../../../ui/api/result.component';
import { AccountBackComponent } from '../../../back/account-back.component';
import { AccountFormComponent } from '../../../form/account-form.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
@Component({
    selector: 'account-edit-form-layout',
    templateUrl: './account-edit-form-layout.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IfSizeDirective, ResultComponent, AccountBackComponent, AccountFormComponent, CommonModule, TranslationModule, GridModule, ActionComponent]
})
export class AccountEditFormLayoutComponent {
    @Input()
    inFormTitle?: string;
    @Input()
    sectionTitle?: string;
    @Input()
    source: any;
}
